import { render, staticRenderFns } from "./DetailGedungBangunanPage.vue?vue&type=template&id=0659b8bc"
import script from "./DetailGedungBangunanPage.vue?vue&type=script&lang=js"
export * from "./DetailGedungBangunanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports